import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';
import { DboDatabaseInstanceV2 } from '@cast/types-database-optimizer';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.getDatabaseInstanceDetails;

export const DBO_DATABASE_INSTANCE_DETAILS_QUERY_KEY =
  'dbo-database-instance-single';

const getDatabaseInstanceDetailsQueryKey = (
  params: Parameters<typeof apiFn>[0]
) => {
  return [DBO_DATABASE_INSTANCE_DETAILS_QUERY_KEY, params] as const;
};

export const useDatabaseInstanceDetailsQuery = <
  TSelected = DboDatabaseInstanceV2
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<DboDatabaseInstanceV2, TSelected>
) =>
  useQuery(
    queryOptions({
      queryKey: getDatabaseInstanceDetailsQueryKey(params),
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      placeholderData: keepPreviousData,
      ...options,
    })
  );
